import { render, staticRenderFns } from "./Connects.vue?vue&type=template&id=bdcccb0c&"
import script from "./Connects.vue?vue&type=script&lang=ts&"
export * from "./Connects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports